import { createGtm } from '@gtm-support/vue-gtm'

import { isDisabledThirdPartyScript, isLocalhost } from '@/utils/browser.js'
import { ternary } from '@/utils/common.js'

const LOCALHOST_GTM_ID = 'GTM-XXX'

window.dataLayer = window.dataLayer || []

const getGTMID = () => {
  // for dev-nomock against real data, replace LOCALHOST_GTM_ID with the dev container id
  return ternary(isLocalhost(), LOCALHOST_GTM_ID, window._GTM_ID)
}

const initGTM = (app, router) => {
  if (isDisabledThirdPartyScript()) {
    return
  }
  app.use(
    createGtm({
      id: getGTMID(),
      debug: false,
      vueRouter: router
    })
  )
}

/**
 * Pushes a single tracking event to the GTM dataLayer.
 * `params` and `ecommerce` are reset first so keys from the previous event
 * are not inherited by this one.
 *
 * @param {Object} data event payload, shaped as { event, params, ecommerce }
 */
const pushToDataLayer = data => {
  window.dataLayer.push({ params: null, ecommerce: null })
  window.dataLayer.push(data)
}

export {
  initGTM,
  pushToDataLayer
}
